import axios from 'axios'
import CryptoJS from 'crypto-js'
import User from '../helpers/user'
// eslint-disable-next-line import/no-cycle
import router from '../src/router'

export const baseUrl = process.env.VUE_APP_API_URL
export const secretKey = process.env.VUE_APP_SECRET_KEY

export function setAuthToken (token) {
  axios.defaults.headers.common.Authorization = `Bearer ${token}`
}

axios.interceptors.request.use(config => {
  const timestamp = Math.floor(Date.now() / 1000)
  const hash = CryptoJS.HmacSHA256(JSON.stringify(timestamp), secretKey)
  config.headers = {
    ...config.headers,
    'X-AUTH-TIMESTAMP': timestamp.toString(),
    'X-AUTH-SIGNATURE': hash.toString()
  }

  return config
})

axios.interceptors.response.use(response => response, error => {
  if (error.response.status === 401) {
    User.signOut()
    router.push('/auth')

  }
  return Promise.reject(error)
})
